<section id="NewSolutions">
    <div class="row">
        <div class="title-section">
            <h3>خدمات ما</h3>
        </div>
        <div class="body-section">
            <div class="column medium-4">
                <a target="_blank" [routerLink]="['/aban/our-services/trading-platforms']">
                    <figure>
                        <img src="assets/images/trading.svg">
                        <figcaption>پلتفرم های معاملاتی</figcaption>
                        <p>سامانه معاملاتی پیشرفته و همراه تریدر</p>
                    </figure>
                </a>
            </div>
            <div class="column medium-4">
                <a target="_blank" [routerLink]="['/aban/our-services/modiriyat-sarmayeh-gozari']">
                    <figure>
                        <img src="assets/images/investment.svg">
                        <figcaption>مدیریت سرمایه شما</figcaption>
                        <p>مدیریت اختصاصی سرمایه گذاری</p>
                    </figure>
                </a>
            </div>
            <div class="column medium-4">
                <a href="http://abandidgah.com/" target="_blank">
                    <figure>
                        <img src="assets/images/graph.svg">
                        <figcaption>تحلیل بازار و شرکت ها</figcaption>
                        <p>به روزترین تحلیل ها در سامانه دیدگاه آبان</p>
                    </figure>
                </a>
            </div>
        </div>
    </div>
</section>